import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import { ENDPOINT_CITIES } from './constants';

export function useCityService() {
  const { backendGet } = Sebrae.useBackend();

  const listCitiesByUf = React.useCallback(
    (uf) => backendGet(`${ENDPOINT_CITIES}`, { 'uf.id': uf.id }),
    [backendGet],
  );

  const listCitiesByIdUf = React.useCallback(
    (idUf) => backendGet(`${ENDPOINT_CITIES}`, { 'uf.id': idUf }),
    [backendGet],
  );

  return {
    listCitiesByUf,
    listCitiesByIdUf,
  };
}
